module.exports = "<router-outlet>\n  <div class=\"loader-wrap loader-wrap-bg\" [ngClass]=\"{'loader-show': dialog.isLoaderVisible()}\">\n    <div class=\"loader-overlay\"></div>\n    <div class=\"loader\">\n      <svg class=\"circular\" viewBox=\"25 25 50 50\">\n        <circle class=\"path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\"></circle> </svg>\n    </div>\n  </div>\n</router-outlet>\n<app-modal></app-modal>\n<notifier-container></notifier-container>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main